import ErrorBoundary from '@/components/ErrorBoundary'
import Footer from '@/components/Footer'
import Hero from '@/components/Hero'
import Navbar from '@/components/Navbar'
import OrderSection from '@/components/OrderSection'
import ProductHighlights from '@/components/ProductHighlights'
import Specifications from '@/components/Specifications'
import { Toaster } from 'react-hot-toast'

function Home() {
  return (
    <ErrorBoundary>
      <div className="bg-zinc-950 min-h-screen">
        <Toaster position="top-center" />
        <Navbar />
        <Hero />
        <ProductHighlights />
        <ErrorBoundary>
          <OrderSection />
        </ErrorBoundary>
        <Specifications />
        <Footer />
      </div>
    </ErrorBoundary>
  )
}

export default Home
